<template>
  <div class="page-container">
    <h1>Document Requests Management</h1>
    <p class="text-muted">An overview of all comprehensive analysis requests.</p>
    <comprehensive-request-dashboard />
  </div>
</template>

<script>
import ComprehensiveRequestDashboard from '@/components/ComprehensiveRequestDashboard.vue';

export default {
  name: 'RequestsView',
  components: {
    ComprehensiveRequestDashboard,
  },
};
</script>

<style scoped>
.page-container {
  padding: var(--spacing-lg);
}
h1 {
  margin-bottom: var(--spacing-xs);
}
.text-muted {
  color: var(--color-text-light);
  margin-bottom: var(--spacing-lg);
}
</style> 